import React, { createContext, useContext, useEffect, useState } from 'react';
import { getAccessToken, setAccessToken, removeTokens, setRefreshToken, setUserInfo } from '../utils/token';
import { refreshToken, loginUser } from '../api/endpoints/auth'; // You can update the path if needed
import {jwtDecode} from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = () => {
    removeTokens();
    setUser(null);
    navigate('/login');
  };

  const handleRefresh = async () => {
    try {
      const res = await refreshToken(); // Calls API to get new token
      if (res?.accessToken) {
        setAccessToken(res.accessToken);
        const decoded = jwtDecode(res.accessToken);
        setUserInfo(decoded);
        setUser(decoded);
      } else {
        logout();
      }
    } catch (err) {
      logout();
    }
  };

  const login = async (username, password) => {
    try {
      const res = await loginUser(username, password ); // make API call
      console.log(res);
      //console.log(res?.data?.success);
      if (res?.data?.success) {
        const details = res.data.data;
        console.log(details);
        setAccessToken(details.token);
        setRefreshToken(details.refresh);
        const userInfo = {
          userId : details.id,
          emailId : details.email_id,
          mobile : details.mobile,
          name : details.name,
          credit: details?.credit,
          role: details.role,
          compId: details?.comp_id,
        }
        setUserInfo(userInfo);
        setUser(userInfo);
      } else {
        throw new Error('Invalid login response');
      }
    } catch (err) {
      console.log(err);
      throw new Error(err?.response?.data?.message || 'Login failed');
    }
  };

  useEffect(() => {
    const token = getAccessToken();
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUser(decoded);
      } catch {
        removeTokens();
      }
    }
    setLoading(false);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        isAuthenticated: !!user,
        login,
        logout,
        refresh: handleRefresh,
        loading,
      }}
    >
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);